import { EZendeskTicketStatus } from "@/types/backoffice/dto/zendesk/zendesk-ticket-dto.ts";

const zendeskLocale = {
  zendesk: {
    ticketId: "ID Ticket",
    ticketStatus: "Statut du ticket",
    assignee: "Assigné",
    ticketSubject: "Sujet",
    createdAt: "Date de création",
    updatedAt: "Date de dernière modification",
    status: {
      [EZendeskTicketStatus.NEW]: "Nouveau",
      [EZendeskTicketStatus.OPEN]: "Ouvert",
      [EZendeskTicketStatus.PENDING]: "Attente",
      [EZendeskTicketStatus.HOLD]: "Pause",
      [EZendeskTicketStatus.SOLVED]: "Résolu",
      [EZendeskTicketStatus.CLOSED]: "Clos",
      [EZendeskTicketStatus.UNKNOWN]: "Inconnu",
    },
  },
};

export type ZendeskLocale = typeof zendeskLocale;
export default zendeskLocale;
